(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.pdvQcInit === '1') return;
    root.dataset.pdvQcInit = '1';
    initCarousel(root);
  }

  function initCarousel(root) {
    var viewport = root.querySelector('[data-pdv-qc-viewport]');
    var track = root.querySelector('[data-pdv-qc-track]');
    var prevBtn = root.querySelector('[data-pdv-qc-prev]');
    var nextBtn = root.querySelector('[data-pdv-qc-next]');
    var dotsEl = root.querySelector('[data-pdv-qc-dots]');
    if (!viewport || !track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-pdv-qc-card]'));
    if (!cards.length) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      if (dotsEl) dotsEl.hidden = true;
      return;
    }

    var page = 0;
    var pages = 1;
    var perPage = 4;

    function getPerPage() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return 4;
    }

    function isMobilePeekScroll() {
      return window.innerWidth <= 749;
    }

    function measure() {
      perPage = getPerPage();
      pages = Math.max(1, Math.ceil(cards.length / perPage));
      if (page > pages - 1) page = pages - 1;

      if (isMobilePeekScroll()) {
        track.style.transform = '';
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        if (dotsEl) dotsEl.hidden = true;
        return;
      }

      renderDots();
      goTo(page, false);
    }

    function renderDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      if (pages <= 1 || isMobilePeekScroll()) {
        dotsEl.hidden = true;
        return;
      }
      dotsEl.hidden = false;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdv-qc__dot' + (i === page ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.setAttribute('aria-current', i === page ? 'true' : 'false');
        (function (index) {
          btn.addEventListener('click', function () {
            goTo(index, true);
          });
        })(i);
        dotsEl.appendChild(btn);
      }
    }

    function goTo(index, animate) {
      if (isMobilePeekScroll()) return;

      page = Math.max(0, Math.min(pages - 1, index));
      var gap = parseFloat(window.getComputedStyle(track).gap) || 16;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var offset = page * perPage * (cardWidth + gap);
      if (!animate) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (!animate) {
        void track.offsetWidth;
        track.style.transition = '';
      }
      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= pages - 1;
      if (dotsEl) {
        var dots = dotsEl.querySelectorAll('.pdv-qc__dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === page);
          dots[i].setAttribute('aria-current', i === page ? 'true' : 'false');
        }
      }
      var showNav = pages > 1;
      if (prevBtn) prevBtn.hidden = !showNav;
      if (nextBtn) nextBtn.hidden = !showNav;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(page - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(page + 1, true);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 120);
    });

    measure();
  }

  function boot() {
    document.querySelectorAll('[data-pdv-qc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pdv-qc]');
    if (root) {
      delete root.dataset.pdvQcInit;
      initSection(root);
    }
  });
})();
